import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import GetSeodata from '../Components/GetSeodata'

function TermsNCondiation() {
  return (
    <>
        <Navbar/>
        <GetSeodata PageName={'terms'} />
        <div className='about-div'>
        <h1>Terms and Conditions</h1>
        <p><i>Home - Terms and Conditions</i></p>

        </div>
        <div className='TermsNCondiation'>
        <h2>1. Booking and Payment</h2>
    <h3> Reservation Confirmation</h3>
    <ul>
        <li>All bookings must be confirmed in writing via email or through our official websites.</li>
        <li>Reservations are only guaranteed upon receipt of the required deposit.</li>
    </ul>

    <h3> Payment Policy</h3>
    <ul>
        <li>A deposit of [specific percentage]% is required at the time of booking.</li>
        <li>The remaining balance must be paid [specific number] days prior to the departure date.</li>
    </ul>

    <h3> Accepted Payment Methods</h3>
    <ul>
        <li>Payments can be made using credit/debit cards, bank transfers, or secure online payment gateways.</li>
    </ul>

    <h3>d. Late Payments</h3>
    <ul>
        <li>Failure to complete payment within the stipulated timeframe may result in cancellation of your booking without a refund.</li>
    </ul>

    <h2>2. Cancellations and Refunds</h2>
    <h3> Cancellation by the Client</h3>
    <ul>
        <li>Cancellations made more than [specific number] days prior to departure are eligible for a [specific percentage]% refund.</li>
        <li>Cancellations made less than [specific number] days before departure are non-refundable.</li>
    </ul>

    <h3> Cancellation by Explera Vacations</h3>
    <ul>
        <li>In the unlikely event that Explera Vacations Co., Ltd. cancels your booking, a full refund will be provided, or an alternative trip arrangement will be offered.</li>
    </ul>

    <h3> No Show Policy</h3>
    <ul>
        <li>No refunds will be issued for clients who fail to show up for scheduled activities or tours.</li>
    </ul>

    <h2>3. Changes and Modifications</h2>
    <h3> Changes by the Client</h3>
    <ul>
        <li>Requests for changes or modifications must be submitted in writing at least [specific number] days before travel.</li>
        <li>Additional charges may apply depending on the nature of the changes.</li>
    </ul>

    <h3> Changes by Explera Vacations</h3>
    <ul>
        <li>We reserve the right to modify itineraries due to unforeseen circumstances, such as weather conditions, strikes, safety concerns, or government restrictions.</li>
        <li>Clients will be informed promptly, and suitable alternatives will be arranged.</li>
    </ul>

    <h2>4. Travel Insurance</h2>
    <ul>
        <li>Clients are required to hold valid travel insurance covering medical emergencies, cancellations, delays, and personal liability.</li>
        <li>Explera Vacations Co., Ltd. shall not be held responsible for any losses or damages incurred during the trip.</li>
    </ul>

    <h2>5. Liability and Responsibility</h2>
    <h3> Client Responsibilities</h3>
    <ul>
        <li>Ensure that passports, visas, and all necessary travel documents are valid and up-to-date before departure.</li>
        <li>Adhere to local laws and respect cultural norms during the trip.</li>
    </ul>

    <h3> Explera Vacations’ Responsibility</h3>
    <ul>
        <li>We act as an intermediary between clients and service providers (hotels, airlines, transportation companies) and are not liable for third-party errors, delays, or issues.</li>
    </ul>

    <h3> Force Majeure</h3>
    <ul>
        <li>Explera Vacations Co., Ltd. is not responsible for cancellations, delays, or losses resulting from events beyond our control, including but not limited to natural disasters, pandemics, or government actions.</li>
    </ul>

    <h2>6. Health and Safety</h2>
    <ul>
        <li>Clients must disclose any pre-existing medical conditions or dietary restrictions during the booking process.</li>
        <li>Compliance with local health and safety regulations is mandatory throughout the trip.</li>
    </ul>

    <h2>7. Privacy Policy</h2>
    <ul>
        <li>Personal data collected during the booking process is used to facilitate reservations and improve service quality.</li>
        <li>For detailed information about data collection and usage, refer to our Privacy Policy.</li>
    </ul>

    <h2>8. Complaints</h2>
    <h3> Complaint Procedure</h3>
    <ul>
        <li>Clients must report any issues or concerns during the trip to our staff immediately to ensure prompt resolution.</li>
    </ul>

    <h3> Post-Trip Complaints</h3>
    <ul>
        <li>Any complaints post-trip must be submitted in writing to <a href="mailto:b2b@expleradmcom">b2b@expleradmcom</a> within 7 days of the trip’s conclusion.</li>
    </ul>

        </div>
        <Footer/>
    </>
  )
}

export default TermsNCondiation